// extracted by css-extract-rspack-plugin
export default {"container":"HfHCoCNd04YjjqSO__container___"};